var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skip-button",on:{"click":function($event){$event.stopPropagation();return _vm.handleSkipClick.apply(null, arguments)}}},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.text)),_c('i',{staticClass:"fas fa-caret-right"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }